let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e9lyC")).then(() => parcelRequire('alq7p'));